import {
  FollowVenueError,
  FollowArtistError
} from "@/plugins/errors/user-errors";

export const validateFollowVenue = error => {
  throw new FollowVenueError(error.message);
};

export const validateFollowArtist = error => {
  throw new FollowArtistError(error.message);
};
